module.exports = __webpack_public_path__ + "static/img/apply6.1542db0a.png";